function generateImagePath(basePath: string, size: string): string {
    const platform = "android"; // default platform
    
    return basePath
        .replace("{platform}", platform)
        .replace("{size}", size);
}

export { generateImagePath };